import { combineReducers } from "redux";
import { projectReducer } from "./ProjectReducer";

const reducer = combineReducers({
  projectProducts: projectReducer,
});

export default reducer;
